import { useState } from 'react'
import './FilterBar.css'

function FilterBar({ onFilterChange, onRefresh, type }) {
  const [searchTerm, setSearchTerm] = useState('')
  const [status, setStatus] = useState('all')

  const handleSearchChange = (e) => {
    const value = e.target.value
    setSearchTerm(value)
    onFilterChange({ searchTerm: value, status })
  }

  const handleStatusChange = (e) => {
    const value = e.target.value
    setStatus(value)
    onFilterChange({ searchTerm, status: value })
  }

  const handleClear = () => {
    setSearchTerm('')
    setStatus('all')
    onFilterChange({ searchTerm: '', status: 'all' })
  }

  return (
    <div className="filter-bar">
      <div className="filter-group">
        <input
          type="text"
          placeholder={type === 'nomination' ? "Search by name, email, surgery, or postcode..." : "Search by name, email, or phone..."}
          value={searchTerm}
          onChange={handleSearchChange}
          className="search-input"
        />

        <select value={status} onChange={handleStatusChange} className="status-filter">
          <option value="all">All Statuses</option>
          <option value="pending">Pending</option>
          {type === 'service' ? (
            <>
              <option value="confirmed">Confirmed</option>
              <option value="rejected">Rejected</option>
            </>
          ) : (
            <option value="completed">Completed</option>
          )}
          <option value="cancelled">Cancelled</option>
        </select>
      </div>

      <div className="filter-actions">
        <button onClick={handleClear} className="button outline">
          Clear Filters
        </button>
        <button onClick={onRefresh} className="button primary">
          Refresh
        </button>
      </div>
    </div>
  )
}

export default FilterBar
